import CategoryService from "@app/services/http/category.service";
import { call, put, takeLatest } from "redux-saga/effects";
import { setCategoryErrorMessage, storeCategories } from "./category.slice";
import { Category, GetAllResponse } from "@app/types";

export const fetchCategoriesAction = () => {
  return {
    type: "@categories/fetchCategoriesAction",
  };
};

function* fetchCategories(): Generator {
  try {
    const categoriesRes = (yield call(
      CategoryService.getAll
    )) as GetAllResponse<Category>;

    if (categoriesRes?.data?.length) {
      yield put(storeCategories(categoriesRes.data));
    } else {
      yield put(storeCategories([]));
    }
  } catch (e: any) {
    yield put(setCategoryErrorMessage(e.message));
  }
}

function* categorySaga() {
  yield takeLatest(fetchCategoriesAction().type, fetchCategories);
}

export default categorySaga;
